import { GeoJsonLayer } from '@deck.gl/layers/typed';
import { parseSync } from '@loaders.gl/core';
import { useEffect, useState } from 'react';
import { WKTLoader } from '@loaders.gl/wkt';
import { useAppSelector } from 'app/store/store';

export const useLayerRoutePlanned = (isRouteBuilderMode?: boolean) => {
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isNotBaseMode = mode === 'analytics' || mode === 'playback';

  const routeBuilded = useAppSelector((state) => state.facadeSlice.routeBuilded.route);

  const [geometry, setGeometry] = useState<any>();

  useEffect(() => {
    setGeometry(null);
  }, [isRouteBuilderMode]);

  useEffect(() => {
    setGeometry(null);

    if (routeBuilded?.geometry) {
      const geometry = parseSync(routeBuilded.geometry, WKTLoader);

      setGeometry(geometry);
    }
  }, [routeBuilded]);

  const routeLayer = new GeoJsonLayer({
    id: 'layer-route-planned',
    visible: isRouteBuilderMode && Boolean(geometry) && !isNotBaseMode,
    data: geometry,
    stroked: true,
    getLineColor: () => {
      const lineColor: [number, number, number, number] = [255, 0, 0, 255];
      return lineColor;
    },

    getLineWidth: 2,
    lineWidthUnits: 'pixels',
  });

  const routeBorderLayer = new GeoJsonLayer({
    id: 'layer-route-planned-border',
    visible: isRouteBuilderMode && Boolean(geometry) && !isNotBaseMode,
    data: geometry,
    stroked: true,
    filled: false,
    getLineColor: [255, 255, 255, 255],
    getLineWidth: 5,
    lineWidthUnits: 'pixels',
  });

  return [routeBorderLayer, routeLayer];
};
